module.exports = __webpack_public_path__ + "images/emoji/keycap_ten.55767072edba51ed9fd7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/keycap_ten.png
// module id = G8jw
// module chunks = 13